angular.module('gym.grading').factory('Gradings', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('grading').all('gradings');
}]);
